export default "__VITE_ASSET__CXPskvZe__"